module.exports = __webpack_public_path__ + "static/media/emoney.b8a540c1.jpg";